import { render, staticRenderFns } from "./Reception.vue?vue&type=template&id=069dc566&scoped=true"
import script from "./Reception.vue?vue&type=script&lang=js"
export * from "./Reception.vue?vue&type=script&lang=js"
import style0 from "./Reception.vue?vue&type=style&index=0&id=069dc566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069dc566",
  null
  
)

export default component.exports